import {LOGO} from "../../assets/images/Images";
import {Link} from "react-router-dom";

export default function Menu() {
    return (
        <div className="header-menu" data-aos="fade-up">
            <Link to={'/'}>
                <img src={LOGO} alt="Company Logo"/>
            </Link>
            <div>
                <a href="#Therapists" className={'btn-appointment'}>Book Appointment</a>
            </div>
        </div>
    )
}

